import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Issuer } from '../types/paymentMethod.types';
import { issuerHelper } from '../utils/issuer.helper';

interface SinglePaymentMethodProps {
  issuer?: Issuer | null;
}

function SinglePaymentMethod({ issuer }: SinglePaymentMethodProps) {
  const { t } = useTranslation();
  const isTemporarilyDisabled = issuerHelper.isPaymentMethodTemporarilyDisabled(issuer?.gatewayIssuerId);

  return (
    <Box
      aria-disabled={isTemporarilyDisabled}
      className={`single-payment-method ${isTemporarilyDisabled ? 'temporarily-disabled' : ''}`}
    >
      <img src={issuer?.issuerImage} alt={`${issuer?.issuerName} logo`} />
      <Box className="data">
        {t('single-payment-method')}
        <span>{issuer?.issuerName}</span>
        {isTemporarilyDisabled && (
          <span className="disabled-text">{t('errors.payment-method-temporarily-disabled')}</span>
        )}
      </Box>
    </Box>
  );
}

export default SinglePaymentMethod;
